var _rect, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGuestGreenCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    fill: "#1EC386",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    stroke: "#1EC386",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89958 7.10526C7.89958 6.68888 8.02305 6.28185 8.25438 5.93564C8.48571 5.58943 8.8145 5.3196 9.19919 5.16025C9.58388 5.00091 10.0072 4.95922 10.4156 5.04045C10.8239 5.12169 11.1991 5.32219 11.4935 5.61662C11.7879 5.91104 11.9884 6.28617 12.0697 6.69455C12.1509 7.10293 12.1092 7.52623 11.9498 7.91091C11.7905 8.2956 11.5207 8.6244 11.1745 8.85573C10.8283 9.08706 10.4212 9.21053 10.0048 9.21053C9.44649 9.21053 8.91101 8.98872 8.51619 8.59391C8.12138 8.1991 7.89958 7.66361 7.89958 7.10526ZM11.0527 10.2632H8.94747C6.81063 10.2632 6.05273 11.8279 6.05273 13.1679C6.05273 14.3684 6.6901 15 7.89484 15H12.1054C13.3117 15 13.9475 14.3684 13.9475 13.1679C13.9475 11.8279 13.1896 10.2632 11.0527 10.2632Z",
    fill: "#1EC386"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGuestGreenCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/guest-green-circle.86c8a506.svg";
export { ForwardRef as ReactComponent };